<template>
  <div :class="isPhone ? 'classroom' : 'classroom classroomPCont'" ref="classroomPCont">
    <Head ref="Head"></Head>
    <div class="pc" v-if="isPhone==false">
      <div class="container" id="container-section-block1">
        <div class="section section1" v-for="(item,index) in menuData" :key="index" :id="'class'+(index+1)">
          <div class="block1" ref="sectionBlock1" @click="changeSec(index)">
            <img alt="xxx" :src="csvw_url + item.coverUrl" style="width: 100%;" />
          </div>
          <div class="block2" ref="sectionBlock2" v-if="secIndex == index">
            <Menu :data="item" :changeItem="changeItem"></Menu>
            <Page :data="item" :pageTitleIndex="pageTitleIndex" :pageIndex="pageIndex"></Page>
            <div class="xiangshangzhedie" @click.stop="arrowUp(index)">
              <img src="@/assets/classroom/imgs/xiangshangzhedie.png" />
            </div>
          </div>
        </div>
<!--        <div class="section section2">-->
<!--          <div class="block1" ref="sectionBlock1" @click="changeSec(1)">-->
<!--            <img alt="xxx" :src="menuData[1].coverUrl" style="width: 100%;" />-->
<!--          </div>-->
<!--          <div class="block2" id="page1" v-if="secIndex==1">-->
<!--            <Menu :data="menuData[1]" :changeItem="changeItem"></Menu>-->
<!--            <Page :data="menuData[1]" :pageTitleIndex="pageTitleIndex" :pageIndex="pageIndex"></Page>-->
<!--            <div class="xiangshangzhedie" @click.stop="arrowUp(1)">-->
<!--              <img src="@/assets/classroom/imgs/xiangshangzhedie.png" />-->
<!--            </div>-->
<!--          </div>-->
<!--        </div>-->
<!--        <div class="section section3">-->
<!--          <div class="block1" ref="sectionBlock1" @click="changeSec(2)">-->
<!--            <img alt="xxx" :src="menuData[2].coverUrl" style="width: 100%;" />-->
<!--          </div>-->
<!--          <div class="block2" id="page2" v-if="secIndex==2">-->
<!--            <Menu :data="menuData[2]" :changeItem="changeItem"></Menu>-->
<!--            <Page :data="menuData[2]" :pageTitleIndex="pageTitleIndex" :pageIndex="pageIndex"></Page>-->
<!--            <div class="xiangshangzhedie" @click.stop="arrowUp(2)">-->
<!--              <img src="@/assets/classroom/imgs/xiangshangzhedie.png" />-->
<!--            </div>-->
<!--          </div>-->
<!--        </div>-->
      </div>
    </div>
    <ClassroomMobile v-if="isPhone"></ClassroomMobile>
    <Foot></Foot>
  </div>
</template>

<script>
// https://www.csvw.com/u/cms/www/202007/30163453pK9k.png
// https://www.csvw.com/u/cms/www/202007/301635440093.png
let data = [];
import ClassroomMobile from "./ClassroomMobile";
import Menu from "./menu/menu";
import Page from "./content/page";
import Head from "../../components/header-index";
import Foot from "../../components/footer-index";
import {
  getBrowserType,
  getBrowserWidth,
  getBrowserHight,
} from "../../components/js/screen";
import { data1 } from "./content/data";
data = data1;
import { csvw_url } from "../../components/config";

let scrollCount1 = 0;
let scrollCount2 = 0;
export default {
  name: "Classroom",
  components: {
    Head,
    Foot,
    ClassroomMobile,
    Menu,
    Page,
  },
  data() {
    return {
      isPhone: false,
      csvw_url:csvw_url,
      secIndex: 10, // 第几个模块
      pageTitleIndex: 0, // 每个模块第几个标题
      pageIndex: 0, // 每个模块第几个页面
      menuData: data,
      scrollIndex: 0,
      canScroll: true, // 是否可以滑动
    };
  },
  mounted: function () {
    document.title = "汽车课堂";
    // 选中改变样式
    $('.newheader .oneul .lilv1:eq(2) > button > span').removeClass('active');
    $('.newheader .oneul .lilv1:eq(5) > button > span').addClass('active');
    // 判断是否手机
    this.getIsPhone();
    // 获取数据
    this.getData();
    var sf = this;
    if (window.addEventListener)
        // older FF
      window.addEventListener("DOMMouseScroll", sf.preventDefault, { passive: false });
    // 获取目标元素
    //     var element = document.getElementById('container-section-block1');
    // debugger
    // // 在目标元素上添加触摸事件监听器
    //     element.addEventListener('touchstart', function(event){
    //       debugger
    //       event.preventDefault();
    //     }, { passive: false });

      // 获取当前页面的 URL 锚点
      var currentHash = window.location.hash;
      console.log("class----------------")

      setTimeout(() => {
        document.querySelector('#' + currentHash.split("#")[1]).scrollIntoView({
          behavior: "auto",
          block: "center",
          inline: "center"
        });
      }, 1000);
  },
  methods: {
    test(event){
      // 这里可以编写触摸事件处理逻辑
      console.log('触摸事件触发');
      // 在这里可以使用 preventDefault 阻止默认的触摸事件行为
      // 例如，禁止滚动
      event.preventDefault();
    },
    getIsPhone() {
      var userAgentInfo = navigator.userAgent;
      var Agents = [
        "Android",
        "iPhone",
        "SymbianOS",
        "Windows Phone",
        "iPad",
        "iPod",
      ];
      for (var v = 0; v < Agents.length; v++) {
        if (userAgentInfo.indexOf(Agents[v]) > 0) {
          this.isPhone = true;
        }
      }

      if (this.isPhone == false) {
        //其他浏览器直接绑定滚动事件
        if (getBrowserType() == "FF") {
          document.addEventListener("DOMMouseScroll", this.scrollFunc,  { passive: false });
        }else {
          document.onmousewheel = this.scrollFunc;
        }
      }
      // 监听键盘
      document.onkeydown = this.scrollKeyFunc;
    },
    getData() {
      this.axios.get(`${csvw_url}/front/news/tcClassCover/list`)
      .then((response) => {
        this.menuData = response.data.data;
        this.addUrl();
      })
      .catch(function (error) {
        console.log(error);
      })
      .finally(() => {});
    },
    addUrl() {
      for (let item of this.menuData) {
        const menu = item.menu;
        for (let menu_item of menu) {
          const subItem = menu_item.subItem;
          for (let subItem_item of subItem) {
            const content = subItem_item.content;
            for (let content_item of content) {
              content_item.contentUrl = `${csvw_url}${content_item.contentUrl}`;
              if (
                  null == content_item.videoUrl ||
                  content_item.videoUrl == ""
              ) {
                content_item.videoUrl = null;
              } else {
                content_item.videoUrl = `${csvw_url}${content_item.videoUrl}`;
              }
            }
          }
        }
      }
      // 给section1Block1 赋值高度
      this.$nextTick(()=>{
        console.log(333,this.$refs.sectionBlock1)
        // let winHeight = getBrowserHight()
        // let headerHeight = this.$refs.Head.$el.offsetHeight
        // let otherHeight = winHeight - headerHeight
        // document.getElementById(`section1Block1`).style.height = otherHeight+'px';
        // alert(this.$refs.Head.offsetHeight)
      })
    },
    // menu 里面的changeItem 将数据传递给page组件
    changeItem(i, j) {
      this.pageTitleIndex = i;
      this.pageIndex = j;
    },
    // 点击查看详情
    changeSec(index) {
      this.secIndex = index;
      setTimeout(() => {
        this.$nextTick(()=>{
          console.log(9999999,this.$refs.sectionBlock2[0],index)
          let h = this.$refs.sectionBlock2[0].offsetTop
          // 滑动到位置
          const type = getBrowserType();
          if (type == "IE" || type == "Chrome") {
            this.$refs.classroomPCont.scrollTo(0, h);
          } else {
            this.$refs.classroomPCont.scrollTo({
              top: h,
              behavior: "smooth",
            });
          }
          this.$refs.classroomPCont.style.overflow='hidden';
        })
      }, 100);
    },
    // 折叠按钮 点击
    arrowUp(index){
      this.secIndex = 10;
      setTimeout(() => {
        this.$nextTick(()=>{
          let h = this.$refs.sectionBlock1[index].offsetTop
          // 滑动到位置
          const type = getBrowserType();
          if (type == "IE") {
            // window.scrollTo(0, h);
            this.$refs.classroomPCont.scrollTo(0, h);
          } else {
            this.$refs.classroomPCont.scrollTo({
              top: h,
              behavior: "smooth",
            });
          }
          this.$refs.classroomPCont.style.overflow='auto';
        })
      }, 100);
    },
    // 鼠标滚动事件
    scrollFunc(e) {
      if(this.secIndex != 10){
        return false
      }
      if (this.secIndex == 10) {
        scrollCount1++;
      } else {
        scrollCount2++;
      }
      if (scrollCount1 >= 1 || scrollCount2 >= 2) {
        e = e || window.event;
        if (e.wheelDelta) {
          //判断浏览器IE，谷歌滑轮事件
          if (e.wheelDelta > 0) {
            //当滑轮向上滚动时
            this.changePage("up");
          }
          if (e.wheelDelta < 0) {
            //当滑轮向下滚动时
            this.changePage("down");
          }
        } else if (e.detail) {
          //Firefox滑轮事件
          if (e.detail > 0) {
            //当滑轮向上滚动时
            this.changePage("down");
          }
          if (e.detail < 0) {
            //当滑轮向下滚动时
            this.changePage("up");
          }
        }
        scrollCount1 = 0;
        scrollCount2 = 0;
      }

      return false; // 加这行不然IE会重复下滑
    },
    // 键盘上下键
    scrollKeyFunc() {
      var e = event || window.event || arguments.callee.caller.arguments[0];
      if ((e && e.keyCode == 38) || (e && e.keyCode == 37)) {
        //上,左
        this.changePage("up");
      }
      if ((e && e.keyCode == 40) || (e && e.keyCode == 39)) {
        //下,右
        this.changePage("down");
      }
      return false; // 加这行不然IE会重复下滑
    },
    // 翻页事件
    changePage(t) {
      if (this.canScroll) {
        this.canScroll = false;
        setTimeout(() => {
          this.canScroll = true;
        }, 100);
        if (t == "down") {
          // 已经拉到最底部
          if (this.scrollIndex == this.menuData.length - 1) {
            return;
          } else {
            this.scrollIndex++;
          }
        } else if (t == "up") {
          if (this.scrollIndex == 0) {
            return;
          }
          if (this.scrollIndex > 0) {
            // 设置移动高度
            let winScrollHeight = this.$refs.classroomPCont.scrollTop
            let len = this.menuData.length
            let section2Block1Height = this.$refs.sectionBlock1[len-1].offsetTop
            if(this.scrollIndex == len-1 && winScrollHeight > section2Block1Height){
            } else {
              this.scrollIndex--;
            }
          }
        }
        // console.log(2222222,this.$refs.sectionBlock1,this.scrollIndex)
        let scollHeight = this.$refs.sectionBlock1[this.scrollIndex].offsetTop
        // console.log(11111,this.scrollIndex,scollHeight)

        // 关闭页面
        this.secIndex = 10;
        setTimeout(() => {
          this.$nextTick(()=>{
            // 滑动到位置
            const type = getBrowserType();
            if (type == "IE") {
              this.$refs.classroomPCont.scrollTo(0,scollHeight);
            } else {
              this.$refs.classroomPCont.scrollTo({
                top: scollHeight,
                behavior: "smooth",
              });
            }
          })
        }, 100);
      }
    },
  },
};
</script>

<style scoped>
body,#app{
  overflow: hidden;
}
/*定义滚动条高宽及背景 高宽分别对应横竖滚动条的尺寸*/
.classroomPCont {
  height: 100vh;
  overflow: auto;
}
/*.classroomPCont::-webkit-scrollbar {*/
/*    width: 0px;*/
/*    height: 0px;*/
/*    background-color: #fafafa;*/
/*  }*/

/*  !*定义滚动条轨道 内阴影+圆角*!*/
/*.classroomPCont::-webkit-scrollbar-track {*/
/*    -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.1);*/
/*    border-radius: 10px;*/
/*    background-color: #fafafa;*/
/*  }*/

/*  !*定义滑块 内阴影+圆角*!*/
/*.classroomPCont::-webkit-scrollbar-thumb {*/
/*    border-radius: 10px;*/
/*    -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.1);*/
/*    background-color: #e5e5e5;*/
/*  }*/
  .classroom {
    position: relative;
  }


  .block1 {
    cursor: pointer;
    height: 100vh;
  }
  .block1 img {
    display: block;
    height: 100%;
    object-fit: cover;
  }
  .block2{
    height: 100vh;
    position: relative;
    padding-bottom: 70px;
    box-sizing: border-box;
  }
  .section1 .block2 {
    position: relative;
    background-image: url("../../assets/classroom/imgs/101.png");
    background-position: center left;
    background-repeat: no-repeat;
    background-size: cover;
  }
  .section2 .block2 {
    position: relative;
    background-image: url("../../assets/classroom/imgs/102.png");
    background-position: center left;
    background-repeat: no-repeat;
    background-size: cover;
  }
  .section3 .block2 {
    position: relative;
    background-image: url("../../assets/classroom/imgs/103.png");
    background-position: center left;
    background-repeat: no-repeat;
    background-size: cover;
  }

.xiangshangzhedie{
  position: absolute;
  bottom: 0;
  left: 0;right: 0;
  height: 70px;
  background: linear-gradient(0deg, rgba(255, 255, 255, 1) 0%, rgba(229, 229, 230, 1) 100%);
  z-index:2 ;
  padding-top: 25px;
  text-align: center;
  box-sizing: border-box;
}
.xiangshangzhedie img{
  height: 26px;
  width: 26px;
  cursor: pointer;
}
@media screen and (min-width: 1px) and (max-width: 1300px) {
  .xiangshangzhedie{
    height: 40px;
    padding-top: 6px;
  }
  .block2{
    padding-bottom: 40px;
  }
}
@media screen and (min-width: 1301px) and (max-width: 1600px) {
  .xiangshangzhedie{
    height: 50px;
    padding-top: 12px;
  }
  .block2{
    padding-bottom: 50px;
  }
}
</style>